export default __webpack_public_path__ + "95f586c32726259d428f6845ccf6bac8.svg";